"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  id: "c1",
  title: "Spinal Interventions",
  column: 1
}, {
  id: "c2",
  title: "Nerve & Joint Blocks",
  column: 1
}, {
  id: "c3",
  title: "Our Clinical Approach",
  column: 2
}, {
  id: "c4",
  title: "Patient Care Path",
  column: 2
}];
const prices = [{
  categoryId: "c1",
  procedure: "Epidural Steroid Injection",
  price: "from €550 | £460"
}, {
  categoryId: "c1",
  procedure: "Facet Joint Injection",
  price: "from €480 | £400"
}, {
  categoryId: "c1",
  procedure: "Sacroiliac Joint Injection",
  price: "from €520 | £435"
}, {
  categoryId: "c1",
  procedure: "Caudal Epidural Block",
  price: "from €450 | £375"
}, {
  categoryId: "c1",
  procedure: "Microdiscectomy",
  price: "from €4,500"
}, {
  categoryId: "c1",
  procedure: "Nucleoplasty",
  price: "from €3,600"
}, {
  categoryId: "c1",
  procedure: "Vertebroplasty",
  price: "from €3,300"
}, {
  categoryId: "c2",
  procedure: "Radiofrequency Ablation",
  price: "from €850 | £710"
}, {
  categoryId: "c2",
  procedure: "Medial Branch Block",
  price: "from €450 | £375"
}, {
  categoryId: "c2",
  procedure: "Selective Nerve Root Block",
  price: "from €600 | £500"
}, {
  categoryId: "c2",
  procedure: "Trigger Point Injections",
  price: "from €180 | £150"
}, {
  categoryId: "c3",
  procedure: "Minimally Invasive Focus",
  price: "Standard"
}, {
  categoryId: "c3",
  procedure: "Targeted Pain Relief",
  price: "Primary"
}, {
  categoryId: "c3",
  procedure: "Expert Diagnostic Blocks",
  price: "Included"
}, {
  categoryId: "c3",
  procedure: "Rapid Recovery Protocols",
  price: "Goal"
}, {
  categoryId: "c4",
  procedure: "Specialist Consultation",
  price: "from €200 | £165"
}, {
  categoryId: "c4",
  procedure: "Treatment Planning",
  price: "Included"
}, {
  categoryId: "c4",
  procedure: "Follow-up Care",
  price: "from €120 | £100"
}];
export default function TransparentPricing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="84635" id="pain-management-procedures" className="bg-secondary/40 py-20 text-foreground">
      <div ref={ref} className={`mx-auto max-w-[1200px] px-4 transition-all duration-700 ease-out md:px-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <h2 className="mb-8 text-3xl font-default font-semibold text-primary tracking-tight">Pain Management</h2>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {}
          <div className="flex flex-col gap-8">
            {categories.filter(c => c.column === 1).map((category, i) => <div key={category.id} data-index={i}>
                  <h3 className="mb-4 text-xl font-default font-semibold text-primary">
                    {category.title}
                  </h3>
                  <Table>
                    <TableBody>
                      {prices.filter(p => p.categoryId === category.id).map((price, j) => <TableRow key={`${category.id}-${j}`} data-index={j} className="border-b border-border bg-background transition-colors hover:bg-accent/20 even:bg-accent/10">
                            <TableCell className="py-3 text-lg font-default text-foreground">
                              {price.procedure}
                            </TableCell>
                            <TableCell className="py-3 text-right text-lg font-default font-medium text-accent-foreground">
                              {price.price}
                            </TableCell>
                          </TableRow>)}
                    </TableBody>
                  </Table>
                </div>)}
          </div>

          {}
          <div className="flex flex-col gap-8">
            {categories.filter(c => c.column === 2).map((category, i) => <div key={category.id} data-index={i}>
                  <h3 className="mb-4 text-xl font-default font-semibold text-primary">
                    {category.title}
                  </h3>
                  <Table>
                    <TableBody>
                      {prices.filter(p => p.categoryId === category.id).map((price, j) => <TableRow key={`${category.id}-${j}`} data-index={j} className="border-b border-border bg-background transition-colors hover:bg-accent/20 even:bg-accent/10">
                            <TableCell className="py-3 text-lg font-default text-foreground">
                              {price.procedure}
                            </TableCell>
                            <TableCell className="py-3 text-right text-lg font-default font-medium text-accent-foreground">
                              {price.price}
                            </TableCell>
                          </TableRow>)}
                    </TableBody>
                  </Table>
                </div>)}
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <Button variant="outline" asChild className="h-auto rounded-full border-primary/20 px-6 py-3 text-[14px] font-default font-semibold text-primary hover:bg-primary hover:text-primary-foreground transition-all shadow-sm">
            <Link to="#">Request Information</Link>
          </Button>
        </div>
      </div>
    </section>;
}